/** Pointer drops follow the cursor; keyboard drops retain center-based navigation. */
import {
  closestCenter,
  pointerWithin,
  type CollisionDetection,
} from "@dnd-kit/core";

/**
 * Compact row handles and the wider drag preview have different centers.
 * Prefer the actual pointer target so an adjacent 24 px row is reachable.
 * @param args - Measured droppables and pointer/keyboard coordinates.
 * @returns Candidates at the pointer, or keyboard-compatible center matches.
 */
export const playerOrderCollision: CollisionDetection = args => {
  const pointed = pointerWithin(args);
  return pointed.length > 0 ? pointed : closestCenter(args);
};
